/** Display the actual batch upload wire contract; never infer intake success. */
export interface FileOutcome {
  name: string
  ok: boolean
  detail: string
}

export interface BatchUploadFileResult {
  filename: string
  success: boolean
  document?: {
    intake_status?: string
    message?: string | null
    reason?: string | null
  } | null
  error?: string | null
}

export function batchUploadOutcomes(results: readonly BatchUploadFileResult[]): FileOutcome[] {
  return results.map((result) => {
    if (!result.success)
      return { name: result.filename, ok: false, detail: result.error ?? 'Upload failed' }
    if (!result.document)
      return { name: result.filename, ok: false, detail: 'Upload result unavailable' }
    const validated = result.document.intake_status === 'validated'
    return {
      name: result.filename,
      ok: validated,
      detail:
        result.document.message ??
        result.document.reason ??
        (validated ? 'in the pipeline' : 'Upload needs review'),
    }
  })
}
